import { createTheme } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: {
      light: '#F8F107',
      lighter: '#F8FF07',
      main: '#F8DD07',
      dark: '#F8C907',
      darker: '#F8B507',
      contrastText: '#212121',
      dullBlack: "#555555"
    },
    secondary: {
      light: '#F8F107',
      lighter: '#F8FF07',
      main: '#F8B507',
      dark: '#F8C907',
      darker: '#F8B507',
      contrastText: '#212121',
    },
    black: {
      main: '#212121',
      contrastText: '#ffffff',
    },
    typography: {
      main: '#212121',
      light: '#555555',
      dark: '#BDBDBD',
      contrastText: '#212121',
    }
  },
  // components: {
  //   MuiTextField: {
  //     styleOverrides: {
  //       root: {
  //         '& label': {
  //           color: '#f7b405',
  //         },
  //         '& label.Mui-focused': {
  //           color: '#f7b405',
  //         },
  //         '& .MuiInput-underline:after': {
  //           borderBottomColor: '#f7b405',
  //         },
  //         '& .MuiOutlinedInput-root': {
  //           '& fieldset': {
  //             borderColor: '#f7b405',
  //           },
  //           '&:hover fieldset': {
  //             borderColor: '#f7b405',
  //           },
  //           '&.Mui-focused fieldset': {
  //             borderColor: '#f7b405',
  //           },
  //         },
  //       },
  //     }
  //   }
  // }
});

export default theme;
